import { useCallback, useState } from 'react';

export const useModal = (onClose?: () => void) => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = useCallback(() => {
    setIsOpen(true);
  }, []);

  const closeModal = useCallback(() => {
    setIsOpen(false);
    onClose && onClose();
  }, [onClose]);

  return {
    isOpen,
    openModal,
    closeModal,
  };
};
